// Main game entry point for Vite build system
import GameConfig from './modules/GameConfig.js';
import AudioManager from './modules/AudioManager.js';
import MovementManager from './modules/MovementManager.js';
import BonusManager from './modules/BonusManager.js';
import GameManager from './modules/GameManager.js';

// Make classes available globally for compatibility
window.GameConfig = GameConfig;
window.AudioManager = AudioManager;
window.MovementManager = MovementManager;
window.BonusManager = BonusManager;
window.GameManager = GameManager;

// Game manager instance
let gameManager;

// Canvas setup and resize function
function resizeCanvas() {
    const canvas = document.getElementById('gameCanvas');
    const headerHeight = 80;
    const footerHeight = 140;
    const availableHeight = window.innerHeight - headerHeight - footerHeight;
    
    canvas.width = window.innerWidth;
    canvas.height = availableHeight;
    
    // Update player position if game manager exists
    if (gameManager && gameManager.movementManager) {
        gameManager.movementManager.updatePlayerPosition();
    }
}

// Initialize the game when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    console.log('🎮 Saboteur Game v' + (__GAME_VERSION__ || '1.0.0'));
    console.log('🏗️ Built on:', __BUILD_DATE__ || 'development');
    
    // Get canvas and set up resizing
    const canvas = document.getElementById('gameCanvas');
    
    // Initialize canvas sizing
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);
    
    // Initialize the game manager
    gameManager = new GameManager(canvas);
    
    // Update version display
    const versionDisplay = document.getElementById('version-display');
    if (versionDisplay) {
        versionDisplay.textContent = 'v' + (__GAME_VERSION__ || '1.0.0');
    }
    
    console.log('Saboteur Game initialized with Vite build system');
});